export enum LocalStorageKeys {
  loginData = "loginData",
  loginToken = "loginToken",
  loginType = "loginType",
}
